module.exports = {
  BANK_ACCOUNT_ISSUER_NAME: {
    CRB: 'CRB'
  }
};
